import { RowSelectedEvent } from '@ag-grid-community/core';
import { Component, OnChanges, OnInit } from '@angular/core';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions, GridRow } from '@app/core/components/grid/grid.types';
import { Item } from '@app/core/components/listbox/listbox.component';
import { DataTaskService } from '@app/core/services/data-task.service';
import { StateService } from '@app/core/services/state.service';
import { BusinesscoItem, LogisticService, StockplaceItem } from '@app/services/logistic.service';
import { TypeaheadService } from '@app/services/typeahead.service';

@Component({
    selector: 'tt-prognosis-purchase-history',
    templateUrl: './prognosis-purchase-history.component.html',
    styleUrls: ['./prognosis-purchase-history.component.css'],
})
export class PrognosisPurchaseHistoryComponent implements OnInit {
    public prognosisPurchaseHistoryKeyno?: string;

    public get?: PrognosisPurchaseHistoryGet;

    public companies: BusinesscoItem[] = [];

    public stockplaces: StockplaceItem[] = [];

    public overviewGrid?: GridOptions;

    public detailGrid?: GridOptions;

    public logGrid?: GridOptions;

    public selectedRow?: GridRow;

    constructor(state: StateService, private datatask: DataTaskService, private logistic: LogisticService, private typeahead: TypeaheadService) {
        let prognosisPurchaseHistoryKeyno = state.getStateParams()['prognosispurchasehistory_keyno'];

        if (!!prognosisPurchaseHistoryKeyno && !isNaN(+prognosisPurchaseHistoryKeyno) && +prognosisPurchaseHistoryKeyno > 0) {
            this.prognosisPurchaseHistoryKeyno = prognosisPurchaseHistoryKeyno;
        }
    }

    public searchSupplier = () => {
        return this.typeahead.searchCustomer({ cust_name: (this.get?.supplier_name ?? '') as string, custtype: 'S' });
    };

    public onSupplierSelected(event?: Item) {
        if (!!this.get) {
            this.get.supplier_no = (event?.item_id ?? '0') as string;
            this.get.supplier_name = (event?.item_name ?? '') as string;
            this.readOverviewGrid();
        }
    }

    public async loadStockplaces() {
        this.stockplaces = await this.logistic.getStockplaces({ businessco_no: (this.get?.businessco_no ?? '0') as string, add_all: '1' });
    }

    public onOverviewGridReady() {
        if (!!this.get && this.get?.prognosispurchasehistory_keyno > '0') {
            const row = this.overviewGrid?.gridfunc?.getRows().find((row) => '' + row['prognosispurchasehistory_keyno'] === '' + this.get?.prognosispurchasehistory_keyno);

            if (!!row) {
                const rowIndex = this.overviewGrid!.gridfunc!.getRowIndex(row);
                this.overviewGrid?.gridfunc?.selectRow(rowIndex);
            }
        } else {
            this.overviewGrid?.gridfunc?.selectRow(0);
        }
    }

    public onPrognosisSelected(event: RowSelectedEvent) {
        console.log('event :>> ', event);
        if (event.node.isSelected()) {
            this.selectedRow = event.data;

            this.readDetailsGrid();
            this.readLogGrid();
        }
    }

    public readOverviewGrid() {
        this.overviewGrid?.gridfunc?.read();
    }

    public readDetailsGrid() {
        if (!this.selectedRow) return;
        if (!this.detailGrid) {
            this.createDetailsGrid();
        } else {
            this.detailGrid.gridfunc?.read();
        }
    }

    public readLogGrid() {
        if (!this.selectedRow) return;
        if (!this.logGrid) {
            this.createLogGrid();
        } else {
            this.logGrid.gridfunc?.read();
        }
    }

    private createOverviewGrid() {
        if (!!this.get) {
            this.overviewGrid = new Grid().setRememberId('prognosispurchasehistory.overview.grid').setLoadDataFunction({ method: 3766, parameters: () => this.get });
        }
    }

    private createDetailsGrid() {
        if (!!this.get && !!this.selectedRow) {
            this.detailGrid = new Grid().setRememberId('prognosispurchasehistory.purchase.grid').setLoadDataFunction({ method: 3765, parameters: () => ({ ...this.get, ...this.selectedRow }) });
        }
    }

    private createLogGrid() {
        if (!!this.get && !!this.selectedRow) {
            this.logGrid = new Grid().setRememberId('prognosispurchasehistory.log.grid').setLoadDataFunction({ method: 3764, parameters: () => ({ ...this.get, ...this.selectedRow }) });
        }
    }

    private async loadCompanies() {
        this.companies = await this.logistic.getCompanies('1');
    }

    private async loadGet() {
        this.get = (await this.datatask.Post(3767, { prognosispurchasehistory_keyno: this.prognosisPurchaseHistoryKeyno }))[0];
    }

    private async init() {
        this.loadCompanies();
        await this.loadGet();
        this.loadStockplaces();
        this.createOverviewGrid();
    }

    ngOnInit(): void {
        this.init();
    }
}

interface PrognosisPurchaseHistoryGet {
    heading: string;
    businessco_no: string;
    stockplace_id: string;
    supplier_no: string;
    supplier_name: string;
    prognosispurchasehistory_keyno: string;
    show_filters: '1' | '0';
    detail_tab: string;
    warning_message: string;
}
